/* eslint-disable @typescript-eslint/ban-types */
import { ReduxMetaData } from '@Types/reduxMetaData.types';

export enum ComponentStatus {
	Running = 'RUNNING',
	New = 'NEW',
	Installed = 'INSTALLED',
	Starting = 'STARTING',
	Finished = 'FINISHED',
	Stopping = 'STOPPING',
	Errored = 'ERRORED',
	Broken = 'BROKEN',
}

export type ComponentData = {
	state: ComponentStatus;
	timestamp: number;
	version: string;
	componentName: string;
};

export type ReportedShadowStatus = {
	state: ComponentData[];
};

export type HeartBeatStatus = {
	status: {
		payload: {
			state: {
				reported?: ReportedHeartBeatStatus;
			};
			metadata: {
				reported: {
					state: Array<
						Partial<
							Record<'timestamp', Partial<{ timestamp: number }>>
						>
					>;
				};
			};
		};
	};
	metadata: object;
};

export type ReportedHeartBeatStatus = {
	state: ComponentData[];
};

export enum HeartBeatStatusIndicators {
	Green = 'green',
	Red = 'red',
	Yellow = 'yellow',
	Disconnected = 'disconnected',
	Disabled = 'disabled',
}

export type HeartBeatStatusResponsePayload = {
	status: {
		payload: {
			state: {
				reported: { state: ComponentData[] };
			};
			metadata: {
				reported: {
					state: Array<
						Partial<
							Record<'timestamp', Partial<{ timestamp: number }>>
						>
					>;
				};
			};
		};
	};
	metadata: object;
};

export interface HeartBeatDetailsStoreState extends ReduxMetaData {
	heartBeatStatus: HeartBeatStatus;
	heartBeatSyncAtTs: number;
	heartbeatSyncCount: number;
}
